export default __webpack_public_path__ + "static/media/icon_facebook.7bdbe79d.webp";